var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.settings.system_settings.free_products > 0
    ? _c(
        "wa-field",
        {
          attrs: {
            name: _vm.settings.is_frontend ? _vm.field.name : "",
            hide_name:
              (_vm.settings.is_frontend && _vm.field.name === "") ||
              !_vm.settings.is_frontend
          }
        },
        [
          !_vm.settings.is_frontend ? _c("hr") : _vm._e(),
          _c(
            "div",
            {
              class: !_vm.settings.is_frontend ? "mb top double clear-both" : ""
            },
            [
              _vm.field.text_before &&
              _vm.field.text_before !== "" &&
              _vm.settings.is_frontend
                ? _c("div", {
                    domProps: { innerHTML: _vm._s(_vm.field.text_before) }
                  })
                : !_vm.settings.is_frontend
                ? _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "Select products, which would be added to certificate"
                        )
                      )
                    )
                  ])
                : _vm._e(),
              _vm.certificate.products.length
                ? _c(
                    "div",
                    { staticClass: "free-products" },
                    [
                      _c(
                        "draggable",
                        {
                          attrs: { handle: ".sort" },
                          model: {
                            value: _vm.selectedProductsList,
                            callback: function($$v) {
                              _vm.selectedProductsList = $$v
                            },
                            expression: "selectedProductsList"
                          }
                        },
                        _vm._l(_vm.selectedProductsList, function(
                          product,
                          index
                        ) {
                          return _c(
                            "div",
                            { key: index, staticClass: "product-item" },
                            [
                              _c("base-icon16", { attrs: { id: "sort" } }),
                              _c("span", {
                                domProps: { innerHTML: _vm._s(product.name) }
                              }),
                              product.sku_name
                                ? _c("span", [
                                    _vm._v(
                                      " (" + _vm._s(product.sku_name) + ")"
                                    )
                                  ])
                                : _vm._e(),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: product.url,
                                    title: _vm.$t("Open product"),
                                    target: "_blank"
                                  }
                                },
                                [
                                  !_vm.settings.is_frontend
                                    ? _c("base-icon16", {
                                        attrs: { id: "new-window" }
                                      })
                                    : _c("i", {
                                        staticClass: "gc-icon new-window"
                                      })
                                ],
                                1
                              ),
                              _c("span", {
                                staticClass: "product-item-price",
                                domProps: { innerHTML: _vm._s(product.price) }
                              }),
                              _c("a", {
                                attrs: { href: "#" },
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.settings.is_frontend
                                      ? _vm.field.remove_products ||
                                          _vm.$t("remove")
                                      : _vm.$t("remove")
                                  )
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.removeSelected(index, product)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "mb top" },
                [
                  _c(
                    "base-modal",
                    {
                      attrs: {
                        text: _vm.settings.is_frontend
                          ? _vm.field.add_products ||
                            '<i class="icon16 add"></i> ' +
                              _vm.$t("add products")
                          : '<i class="icon16 add"></i> ' +
                            _vm.$t("add products"),
                        title: _vm.$t("Adding products"),
                        component: _vm.productSearchComponent,
                        componentParams: {
                          url: this.settings.urls.get_products_search_data,
                          selected: {
                            url: this.settings.urls
                              .get_products_search_selected,
                            data: _vm.modalSelectedProducts
                          },
                          settings: _vm.settings
                        },
                        buttons: {
                          submit: {
                            name: _vm.$t("Save"),
                            onSave: _vm.onProductsSearchSave,
                            closeOnSubmit: true
                          }
                        },
                        footer: {
                          component: _vm.productSearchFooterComponent
                        },
                        modalParams: {
                          height: "90%",
                          fixedFooter: true,
                          contentId: "products-search-content",
                          closeCross: true
                        }
                      }
                    },
                    [_vm._v(" \n            ")]
                  )
                ],
                1
              ),
              _vm.field.text_after &&
              _vm.field.text_after !== "" &&
              _vm.settings.is_frontend
                ? _c("div", {
                    domProps: { innerHTML: _vm._s(_vm.field.text_after) }
                  })
                : _vm._e()
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }